import { useStorage } from 'Components/Storage';

const getLocale = () => {
  const [storage] = useStorage();
  const lang = storage.language;

  switch (lang) {
    case 'se':
      return 'sv';
    case 'en':
      return 'en';
    case 'no':
      return 'nb';
    case 'dk':
      return 'da';
    case 'tr':
      return 'tr';
    default:
      return 'en';
  }
};

export default getLocale;
